import axios from 'axios'
import { GetBaseUrl } from '@/utils/ConfigHelper'
import Response from '@/utils/Videomonster/Common/Response'
import { PUBLIC_ERROR_CODE } from '@/utils/Error/Constants'
import { GetPublicErrorCode } from '@/utils/Error/Handler'

/**
 * productId를 인자로 받아 ProductInfo를 가져오는 API 호출 Method
 * - 호출 API : GET /api/product/info
 * @param {{ productId: String }} data 
 */
const GetProductInfo = async (data = {}) => {
    try {
        const { productId } = data
        const url = `${GetBaseUrl()}/api/product/info?id=${productId}`
        const response = await axios.get(url)

        const result = response.status === 200
        const resultData = response.data.info

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

export default {
    GetProductInfo
}